export const getDiaryActivities = (state) => state.diaryContext.activities

export const isDiaryListActive = (state) => state.diaryContext.activities.isListActive

export const isDiaryCalendarActive = (state) => state.diaryContext.activities.isCalendarActive
